/**
 * Virtual Wall of Hope - interlocking bento mosaic.
 * Assigns tile sizes for dense CSS grid packing + read-more toggles.
 */

const SIZE_CYCLE = [ 'wide', 'tall', 's', 'm', 'feature', 's', 'bar', 'sq', 'tall', 'm', 'wide', 's' ];

function assignSizes( tiles ) {
	tiles.forEach( ( tile, index ) => {
		const size = SIZE_CYCLE[ index % SIZE_CYCLE.length ];

		tile.classList.remove(
			'bts-hope-tile--wide',
			'bts-hope-tile--feature',
			'bts-hope-tile--sq',
			'bts-hope-tile--tall',
			'bts-hope-tile--m',
			'bts-hope-tile--s',
			'bts-hope-tile--bar'
		);
		tile.classList.add( `bts-hope-tile--${ size }` );
		tile.dataset.size = size;
	} );
}

function updateToggles( tiles ) {
	tiles.forEach( ( tile ) => {
		const text = tile.querySelector( '.bts-hope-tile__text' );
		const toggle = tile.querySelector( '.bts-hope-tile__toggle' );

		if ( ! text || ! toggle || tile.classList.contains( 'is-expanded' ) ) {
			return;
		}

		toggle.hidden = text.scrollHeight <= text.clientHeight + 1;
	} );
}

function initReveal( section, tiles ) {
	if (
		! ( 'IntersectionObserver' in window ) ||
		window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ||
		document.body.classList.contains( 'elementor-editor-active' )
	) {
		return;
	}

	section.classList.add( 'is-animated' );

	const observer = new IntersectionObserver(
		( entries ) => {
			entries
				.filter( ( entry ) => entry.isIntersecting )
				.forEach( ( entry, index ) => {
					entry.target.style.transitionDelay = `${ index * 70 }ms`;
					entry.target.classList.add( 'is-visible' );
					observer.unobserve( entry.target );
				} );
		},
		{ threshold: 0.1 }
	);

	tiles.forEach( ( tile ) => observer.observe( tile ) );
}

function initBento( section ) {
	const mosaic = section.querySelector( '.bts-hope-bento__mosaic' );

	if ( ! mosaic ) {
		return;
	}

	const tiles = Array.from( mosaic.querySelectorAll( '.bts-hope-tile' ) );

	assignSizes( tiles );

	const refresh = () => updateToggles( tiles );

	mosaic.addEventListener( 'click', ( event ) => {
		const toggle = event.target.closest( '.bts-hope-tile__toggle' );

		if ( ! toggle ) {
			return;
		}

		const tile = toggle.closest( '.bts-hope-tile' );
		const expanded = tile.classList.toggle( 'is-expanded' );

		toggle.setAttribute( 'aria-expanded', String( expanded ) );
		toggle.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
		refresh();
	} );

	let resizeTimer;
	window.addEventListener( 'resize', () => {
		window.clearTimeout( resizeTimer );
		resizeTimer = window.setTimeout( refresh, 120 );
	} );

	refresh();
	initReveal( section, tiles );
}

export default function initHopeBento() {
	document.querySelectorAll( '.bts-hope-bento' ).forEach( initBento );
}
